export default __webpack_public_path__ + "static/media/NeueHaasUnicaW02-Bold.9fc0adfd.ttf";